import { render, staticRenderFns } from "./CategoriesWall.vue?vue&type=template&id=77ad719a&scoped=true"
import script from "./CategoriesWall.vue?vue&type=script&lang=js"
export * from "./CategoriesWall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ad719a",
  null
  
)

export default component.exports